// extracted by mini-css-extract-plugin
export default {"tableAvatar":"userPerformanceTable_tableAvatar__Ue+0U","tableAvatar__img":"userPerformanceTable_tableAvatar__img__2LVqX","rank":"userPerformanceTable_rank__mUHFc"};